import styled from 'styled-components';

export const Fields = styled.div`
  display: grid;
`;

export const GroupTitle = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  font-weight: 600;
  line-height: 24px;
  text-align: start;
  padding-block: 8px;

  border-bottom: 1px solid #dee2db;
  margin-bottom: 24px;

  grid-column 1 / -1;
  align-self: stretch;
`;
